/**
 * MechaGuard - LaserTower (激光塔)
 *
 * 攻击方式：持续光束（高频命中判定）
 * 定位：造价最低的单体输出塔，射速快、伤害稳定。
 * 满级特性：双束发射 —— 同时锁定第二个目标，造成 70% 伤害。
 */

import { Tower } from '../entities/Tower.js';

export class LaserTower extends Tower {
  static META = {
    id: 'laser',
    name: '激光塔',
    icon: '⚡',
    cost: 100,
    desc: '持续光束，单体稳定输出',
    color: '#00ffff',
    stats: {
      baseRange: 118,
      baseDamage: 5,
      fireInterval: 0.12,   // ≈ 41.7 DPS
      barrelLength: 17,
      turnSpeed: 12,
      firingFx: 0.06,
      secondaryFactor: 0.7, // 满级副束伤害比例
    },
  };

  constructor(col, row) {
    super(col, row);
  }

  update(dt, game) {
    this.tickTimers(dt);

    const target = this.findTarget(game.enemies);
    this.target = target;

    if (!target) return;

    this.aimAt(target, dt, this.turnSpeed);

    if (this.cooldown > 0) return;

    this.cooldown = this.fireInterval;
    this.firing = this.firingFx;
    game.sfx('laser');

    const mx = this.x + Math.cos(this.angle) * this.barrelLength;
    const my = this.y + Math.sin(this.angle) * this.barrelLength;

    // 主束
    const dealt = game.damageEnemy(target, this.damage);
    this.totalDamage += dealt;
    game.effects.addBeam(mx, my, target.x, target.y, this.color, this.fireInterval * 1.8);
    game.particles.spawnHit(target.x, target.y, this.color, 1);

    // 满级：副束
    if (this.level >= 3) {
      const second = this._findSecondTarget(game.enemies, target);
      if (second) {
        const dealt2 = game.damageEnemy(second, this.damage * this.secondaryFactor);
        this.totalDamage += dealt2;
        game.effects.addBeam(mx, my, second.x, second.y, this.color, this.fireInterval * 1.8);
        game.particles.spawnHit(second.x, second.y, this.color, 1);
      }
    }
  }

  /** 在射程内找另一个目标（排除主目标） */
  _findSecondTarget(enemies, exclude) {
    const r2 = this.range * this.range;
    let best = null;

    for (let i = 0; i < enemies.length; i++) {
      const e = enemies[i];
      if (e === exclude || !e.alive || e.reachedBase) continue;
      if (e.distanceSqTo(this.x, this.y) > r2) continue;
      if (best === null || e.pathProgress > best.pathProgress) best = e;
    }

    return best;
  }

  drawTurret(ctx, accent) {
    ctx.fillStyle = 'rgba(10, 24, 42, 0.92)';
    ctx.strokeStyle = accent;
    ctx.lineWidth = 2;

    ctx.beginPath();
    ctx.moveTo(-7, -6);
    ctx.lineTo(9, -3.5);
    ctx.lineTo(14, 0);
    ctx.lineTo(9, 3.5);
    ctx.lineTo(-7, 6);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();

    // 发射口
    ctx.shadowColor = accent;
    ctx.shadowBlur = 10;
    ctx.fillStyle = accent;
    ctx.beginPath();
    ctx.arc(14, 0, 2.6, 0, Math.PI * 2);
    ctx.fill();
    ctx.shadowBlur = 0;

    // 满级时显示双束标记
    if (this.level >= 3) {
      ctx.fillStyle = 'rgba(255,255,255,0.85)';
      ctx.fillRect(-2, -9, 3, 3);
      ctx.fillRect(-2, 6, 3, 3);
    }
  }
}
